import { MoreHoriz } from "@mui/icons-material";
import { Box, Menu, MenuItem } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { node_server } from "../../../../../../../../../constants";
import styles from "./style.module.css";

const Options = ({ setStatus, item }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleRemove = async () => {
		handleClose();
		setStatus("Accepted");
		const response = await axios.post(
			`${node_server}/api/projects/applications-status`,
			{
				projectId: item.project_id,
				userId: item.user_id,
				status: "Accepted",
			},
			{ withCredentials: true },
		);
		const error = response.status !== 200 ? response.data : null;

		if (error) {
			throw error;
		}
	};

	return (
		<Box className={styles.dots}>
			<MoreHoriz
				sx={{ fill: "#A4A2A2" }}
				id="basic-button"
				aria-controls={open ? "basic-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
			/>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
			>
				<MenuItem onClick={handleRemove}>
					Remove Completed Status
				</MenuItem>
			</Menu>
		</Box>
	);
};

export default Options;
